import verifyImage from '../../assets/image.svg';
import { msFormVerification } from "../common/constants";

const ConsentAndDisclosureGroup2 = (props) => {
    const { onVerifyClearHandler, displayData } = props;
return (
    <div className="consent-disclosure">
        <div className="white-box consent-disclosure-specific">
        <div className="consent-disclosure-header">Biometric Identity Verification Through CLEAR
<br/>Consent Disclosure</div>
<div className="consent-disclosure-description">
   {displayData[0]?.consent_language}
</div>
<button
                className="verify-button"
                id="verify_button_d"
                type="button"
                onClick={()=> onVerifyClearHandler(displayData[0]?.consent_id)}
              > <img src={verifyImage} alt="Verify with CLEAR" />
                {
                    displayData[0]?.button_text_inner
                }
              </button>
</div>
<div  className="white-box consent-disclosure-specific">
        <div className="consent-disclosure-header">Another Way to Verify Your Identity
<br/>Consent Disclosure</div>
<div className="consent-disclosure-description">
{displayData[1]?.consent_language}

</div>
<button 
                className="verify-button"
                id="verify_button_d"
                type="button"
                onClick={()=> onVerifyClearHandler(displayData[1]?.consent_id)}
                // onClick={() => window.open(msFormVerification, '_blank', 'noopener,noreferrer')}
              >
                {
                    displayData[1]?.button_text_inner
                } 
              </button>
</div>
    </div>
)
}

export default ConsentAndDisclosureGroup2;

